import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/about-us',
    component: ComponentCreator('/about-us', '8af'),
    exact: true
  },
  {
    path: '/ai-pdf-generator',
    component: ComponentCreator('/ai-pdf-generator', 'ad0'),
    exact: true
  },
  {
    path: '/blog',
    component: ComponentCreator('/blog', 'acc'),
    exact: true
  },
  {
    path: '/blog/apache-pdfbox-java-tutorial-generate-pdfs',
    component: ComponentCreator('/blog/apache-pdfbox-java-tutorial-generate-pdfs', 'a39'),
    exact: true
  },
  {
    path: '/blog/api-integration-essentials',
    component: ComponentCreator('/blog/api-integration-essentials', '80c'),
    exact: true
  },
  {
    path: '/blog/archive',
    component: ComponentCreator('/blog/archive', '182'),
    exact: true
  },
  {
    path: '/blog/authors',
    component: ComponentCreator('/blog/authors', '0b7'),
    exact: true
  },
  {
    path: '/blog/compress-pdf-api',
    component: ComponentCreator('/blog/compress-pdf-api', '17f'),
    exact: true
  },
  {
    path: '/blog/csharp-generate-pdf-pdfsharp',
    component: ComponentCreator('/blog/csharp-generate-pdf-pdfsharp', '62d'),
    exact: true
  },
  {
    path: '/blog/generate-html-to-pdf-with-jspdf',
    component: ComponentCreator('/blog/generate-html-to-pdf-with-jspdf', 'f0a'),
    exact: true
  },
  {
    path: '/blog/generate-invoice-pdf-api',
    component: ComponentCreator('/blog/generate-invoice-pdf-api', '38f'),
    exact: true
  },
  {
    path: '/blog/generate-pdf-csharp-questpdf',
    component: ComponentCreator('/blog/generate-pdf-csharp-questpdf', '4a1'),
    exact: true
  },
  {
    path: '/blog/generate-pdf-from-html-using-itext-and-java',
    component: ComponentCreator('/blog/generate-pdf-from-html-using-itext-and-java', '2fc'),
    exact: true
  },
  {
    path: '/blog/generate-pdf-nodejs-puppeteer',
    component: ComponentCreator('/blog/generate-pdf-nodejs-puppeteer', '8c3'),
    exact: true
  },
  {
    path: '/blog/generate-pdf-pdf-lib-nodejs',
    component: ComponentCreator('/blog/generate-pdf-pdf-lib-nodejs', 'fe0'),
    exact: true
  },
  {
    path: '/blog/generate-pdf-pdfkit-nodejs',
    component: ComponentCreator('/blog/generate-pdf-pdfkit-nodejs', '65b'),
    exact: true
  },
  {
    path: '/blog/generate-pdf-pdfmake-nodejs',
    component: ComponentCreator('/blog/generate-pdf-pdfmake-nodejs', '0cd'),
    exact: true
  },
  {
    path: '/blog/generate-pdf-python-pyppeteer',
    component: ComponentCreator('/blog/generate-pdf-python-pyppeteer', 'e81'),
    exact: true
  },
  {
    path: '/blog/generate-pdf-templates-with-ai',
    component: ComponentCreator('/blog/generate-pdf-templates-with-ai', 'a65'),
    exact: true
  },
  {
    path: '/blog/how-to-convert-html-to-pdf-using-api',
    component: ComponentCreator('/blog/how-to-convert-html-to-pdf-using-api', 'b18'),
    exact: true
  },
  {
    path: '/blog/how-to-generate-pdfs-in-2025',
    component: ComponentCreator('/blog/how-to-generate-pdfs-in-2025', 'bbb'),
    exact: true
  },
  {
    path: '/blog/html-template-engines',
    component: ComponentCreator('/blog/html-template-engines', '9f7'),
    exact: true
  },
  {
    path: '/blog/html-to-pdf-conversion',
    component: ComponentCreator('/blog/html-to-pdf-conversion', '310'),
    exact: true
  },
  {
    path: '/blog/html-to-pdf-csharp-dinktopdf',
    component: ComponentCreator('/blog/html-to-pdf-csharp-dinktopdf', '4fd'),
    exact: true
  },
  {
    path: '/blog/html-to-pdf-header-footer-examples',
    component: ComponentCreator('/blog/html-to-pdf-header-footer-examples', 'de4'),
    exact: true
  },
  {
    path: '/blog/html-to-pdf-itext7',
    component: ComponentCreator('/blog/html-to-pdf-itext7', 'b1b'),
    exact: true
  },
  {
    path: '/blog/html-to-pdf-java-flying-saucer',
    component: ComponentCreator('/blog/html-to-pdf-java-flying-saucer', '801'),
    exact: true
  },
  {
    path: '/blog/html-to-pdf-java-playwright',
    component: ComponentCreator('/blog/html-to-pdf-java-playwright', '331'),
    exact: true
  },
  {
    path: '/blog/html-to-pdf-playwright-csharp-dotnet',
    component: ComponentCreator('/blog/html-to-pdf-playwright-csharp-dotnet', '08d'),
    exact: true
  },
  {
    path: '/blog/html-to-pdf-puppeteersharp',
    component: ComponentCreator('/blog/html-to-pdf-puppeteersharp', '211'),
    exact: true
  },
  {
    path: '/blog/html-to-pdf-rails-puppeteer-ruby',
    component: ComponentCreator('/blog/html-to-pdf-rails-puppeteer-ruby', '18e'),
    exact: true
  },
  {
    path: '/blog/n8n-invoice-automation',
    component: ComponentCreator('/blog/n8n-invoice-automation', 'd22'),
    exact: true
  },
  {
    path: '/blog/n8n-pdf-automation-guide',
    component: ComponentCreator('/blog/n8n-pdf-automation-guide', '67b'),
    exact: true
  },
  {
    path: '/blog/n8n-pdf-workflow-templates',
    component: ComponentCreator('/blog/n8n-pdf-workflow-templates', '30b'),
    exact: true
  },
  {
    path: '/blog/openpdf-java-pdf-generation',
    component: ComponentCreator('/blog/openpdf-java-pdf-generation', '07c'),
    exact: true
  },
  {
    path: '/blog/optimizing-html-for-pdf',
    component: ComponentCreator('/blog/optimizing-html-for-pdf', '02c'),
    exact: true
  },
  {
    path: '/blog/page/2',
    component: ComponentCreator('/blog/page/2', '6a7'),
    exact: true
  },
  {
    path: '/blog/page/3',
    component: ComponentCreator('/blog/page/3', 'a5b'),
    exact: true
  },
  {
    path: '/blog/page/4',
    component: ComponentCreator('/blog/page/4', '11c'),
    exact: true
  },
  {
    path: '/blog/page/5',
    component: ComponentCreator('/blog/page/5', '8b1'),
    exact: true
  },
  {
    path: '/blog/page/6',
    component: ComponentCreator('/blog/page/6', '2f2'),
    exact: true
  },
  {
    path: '/blog/pdf-accessibility',
    component: ComponentCreator('/blog/pdf-accessibility', 'd48'),
    exact: true
  },
  {
    path: '/blog/pdf-format',
    component: ComponentCreator('/blog/pdf-format', '7b9'),
    exact: true
  },
  {
    path: '/blog/pdf-templates',
    component: ComponentCreator('/blog/pdf-templates', 'eff'),
    exact: true
  },
  {
    path: '/blog/pdfbox-compress-pdf-java',
    component: ComponentCreator('/blog/pdfbox-compress-pdf-java', 'ef1'),
    exact: true
  },
  {
    path: '/blog/php-html-to-pdf-dompdf',
    component: ComponentCreator('/blog/php-html-to-pdf-dompdf', '4f3'),
    exact: true
  },
  {
    path: '/blog/print-ready-pdf-generation-pdfx1a-pdfx4',
    component: ComponentCreator('/blog/print-ready-pdf-generation-pdfx1a-pdfx4', '20c'),
    exact: true
  },
  {
    path: '/blog/python-html-to-pdf-library',
    component: ComponentCreator('/blog/python-html-to-pdf-library', '864'),
    exact: true
  },
  {
    path: '/blog/python-html-to-pdf-pdfkit',
    component: ComponentCreator('/blog/python-html-to-pdf-pdfkit', '8e5'),
    exact: true
  },
  {
    path: '/blog/python-html-to-pdf-weasyprint-pypdf2',
    component: ComponentCreator('/blog/python-html-to-pdf-weasyprint-pypdf2', '471'),
    exact: true
  },
  {
    path: '/blog/python-html-to-pdf-xhtml2pdf',
    component: ComponentCreator('/blog/python-html-to-pdf-xhtml2pdf', '516'),
    exact: true
  },
  {
    path: '/blog/ruby-rails-html-to-pdf-grover',
    component: ComponentCreator('/blog/ruby-rails-html-to-pdf-grover', '704'),
    exact: true
  },
  {
    path: '/blog/ruby-rails-html-to-pdf-wickedpdf',
    component: ComponentCreator('/blog/ruby-rails-html-to-pdf-wickedpdf', 'ade'),
    exact: true
  },
  {
    path: '/blog/ruby-rails-pdf-generation-hexapdf',
    component: ComponentCreator('/blog/ruby-rails-pdf-generation-hexapdf', '660'),
    exact: true
  },
  {
    path: '/blog/ruby-rails-pdf-generation-prawn',
    component: ComponentCreator('/blog/ruby-rails-pdf-generation-prawn', 'bf6'),
    exact: true
  },
  {
    path: '/blog/save-webpage-to-pdf-chrome-extension',
    component: ComponentCreator('/blog/save-webpage-to-pdf-chrome-extension', 'd84'),
    exact: true
  },
  {
    path: '/blog/tags',
    component: ComponentCreator('/blog/tags', '287'),
    exact: true
  },
  {
    path: '/blog/tags/accessibility-testing',
    component: ComponentCreator('/blog/tags/accessibility-testing', 'af6'),
    exact: true
  },
  {
    path: '/blog/tags/accessible-documents',
    component: ComponentCreator('/blog/tags/accessible-documents', 'b8e'),
    exact: true
  },
  {
    path: '/blog/tags/ada-compliance',
    component: ComponentCreator('/blog/tags/ada-compliance', '52c'),
    exact: true
  },
  {
    path: '/blog/tags/ai-document',
    component: ComponentCreator('/blog/tags/ai-document', 'ed0'),
    exact: true
  },
  {
    path: '/blog/tags/ai-document-generator',
    component: ComponentCreator('/blog/tags/ai-document-generator', '84e'),
    exact: true
  },
  {
    path: '/blog/tags/ai-pdf-generator',
    component: ComponentCreator('/blog/tags/ai-pdf-generator', '197'),
    exact: true
  },
  {
    path: '/blog/tags/ai-templates',
    component: ComponentCreator('/blog/tags/ai-templates', '36a'),
    exact: true
  },
  {
    path: '/blog/tags/apache-pdfbox',
    component: ComponentCreator('/blog/tags/apache-pdfbox', 'fd4'),
    exact: true
  },
  {
    path: '/blog/tags/api',
    component: ComponentCreator('/blog/tags/api', '3d8'),
    exact: true
  },
  {
    path: '/blog/tags/api-integration',
    component: ComponentCreator('/blog/tags/api-integration', 'a46'),
    exact: true
  },
  {
    path: '/blog/tags/api-integration-example',
    component: ComponentCreator('/blog/tags/api-integration-example', 'dbf'),
    exact: true
  },
  {
    path: '/blog/tags/automated-invoice-generation',
    component: ComponentCreator('/blog/tags/automated-invoice-generation', '450'),
    exact: true
  },
  {
    path: '/blog/tags/browser-automation',
    component: ComponentCreator('/blog/tags/browser-automation', '149'),
    exact: true
  },
  {
    path: '/blog/tags/browser-extension',
    component: ComponentCreator('/blog/tags/browser-extension', 'b12'),
    exact: true
  },
  {
    path: '/blog/tags/browser-pdf',
    component: ComponentCreator('/blog/tags/browser-pdf', '008'),
    exact: true
  },
  {
    path: '/blog/tags/c-generate-pdf',
    component: ComponentCreator('/blog/tags/c-generate-pdf', '8cf'),
    exact: true
  },
  {
    path: '/blog/tags/c-html-to-pdf',
    component: ComponentCreator('/blog/tags/c-html-to-pdf', '3a7'),
    exact: true
  },
  {
    path: '/blog/tags/c-pdf-generation',
    component: ComponentCreator('/blog/tags/c-pdf-generation', '887'),
    exact: true
  },
  {
    path: '/blog/tags/certificate-pdf',
    component: ComponentCreator('/blog/tags/certificate-pdf', '112'),
    exact: true
  },
  {
    path: '/blog/tags/chrome-extension',
    component: ComponentCreator('/blog/tags/chrome-extension', '25b'),
    exact: true
  },
  {
    path: '/blog/tags/client-side',
    component: ComponentCreator('/blog/tags/client-side', 'cb0'),
    exact: true
  },
  {
    path: '/blog/tags/client-side-pdf-generation',
    component: ComponentCreator('/blog/tags/client-side-pdf-generation', '73a'),
    exact: true
  },
  {
    path: '/blog/tags/cmyk',
    component: ComponentCreator('/blog/tags/cmyk', 'c5b'),
    exact: true
  },
  {
    path: '/blog/tags/compress-pdf',
    component: ComponentCreator('/blog/tags/compress-pdf', '2c0'),
    exact: true
  },
  {
    path: '/blog/tags/contract-pdf',
    component: ComponentCreator('/blog/tags/contract-pdf', 'e1e'),
    exact: true
  },
  {
    path: '/blog/tags/convert-html-to-pdf',
    component: ComponentCreator('/blog/tags/convert-html-to-pdf', '62d'),
    exact: true
  },
  {
    path: '/blog/tags/convert-webpage-to-pdf',
    component: ComponentCreator('/blog/tags/convert-webpage-to-pdf', '68c'),
    exact: true
  },
  {
    path: '/blog/tags/create-pdf-template',
    component: ComponentCreator('/blog/tags/create-pdf-template', 'f81'),
    exact: true
  },
  {
    path: '/blog/tags/csharp',
    component: ComponentCreator('/blog/tags/csharp', '9e1'),
    exact: true
  },
  {
    path: '/blog/tags/csharp-html-to-pdf',
    component: ComponentCreator('/blog/tags/csharp-html-to-pdf', '70d'),
    exact: true
  },
  {
    path: '/blog/tags/csharp-html-to-pdf-library',
    component: ComponentCreator('/blog/tags/csharp-html-to-pdf-library', '24c'),
    exact: true
  },
  {
    path: '/blog/tags/csharp-pdf-generation-library',
    component: ComponentCreator('/blog/tags/csharp-pdf-generation-library', 'fee'),
    exact: true
  },
  {
    path: '/blog/tags/css-for-print',
    component: ComponentCreator('/blog/tags/css-for-print', 'c9a'),
    exact: true
  },
  {
    path: '/blog/tags/digital-documents',
    component: ComponentCreator('/blog/tags/digital-documents', '9a7'),
    exact: true
  },
  {
    path: '/blog/tags/dinktopdf',
    component: ComponentCreator('/blog/tags/dinktopdf', 'b04'),
    exact: true
  },
  {
    path: '/blog/tags/display-header-footer',
    component: ComponentCreator('/blog/tags/display-header-footer', 'a6d'),
    exact: true
  },
  {
    path: '/blog/tags/docraptor',
    component: ComponentCreator('/blog/tags/docraptor', 'daf'),
    exact: true
  },
  {
    path: '/blog/tags/document-automation',
    component: ComponentCreator('/blog/tags/document-automation', 'afc'),
    exact: true
  },
  {
    path: '/blog/tags/document-format',
    component: ComponentCreator('/blog/tags/document-format', '960'),
    exact: true
  },
  {
    path: '/blog/tags/document-formatting',
    component: ComponentCreator('/blog/tags/document-formatting', 'f4e'),
    exact: true
  },
  {
    path: '/blog/tags/document-generation',
    component: ComponentCreator('/blog/tags/document-generation', 'b7a'),
    exact: true
  },
  {
    path: '/blog/tags/dompdf',
    component: ComponentCreator('/blog/tags/dompdf', '765'),
    exact: true
  },
  {
    path: '/blog/tags/dotnet',
    component: ComponentCreator('/blog/tags/dotnet', '9c1'),
    exact: true
  },
  {
    path: '/blog/tags/dotnet-pdf-library',
    component: ComponentCreator('/blog/tags/dotnet-pdf-library', '9c6'),
    exact: true
  },
  {
    path: '/blog/tags/dynamic-pdf-generation',
    component: ComponentCreator('/blog/tags/dynamic-pdf-generation', 'f4e'),
    exact: true
  },
  {
    path: '/blog/tags/ejs',
    component: ComponentCreator('/blog/tags/ejs', '2cc'),
    exact: true
  },
  {
    path: '/blog/tags/erb-templates',
    component: ComponentCreator('/blog/tags/erb-templates', '31a'),
    exact: true
  },
  {
    path: '/blog/tags/expressjs',
    component: ComponentCreator('/blog/tags/expressjs', 'd50'),
    exact: true
  },
  {
    path: '/blog/tags/ferrum-pdf-gem',
    component: ComponentCreator('/blog/tags/ferrum-pdf-gem', 'e7f'),
    exact: true
  },
  {
    path: '/blog/tags/financial-report',
    component: ComponentCreator('/blog/tags/financial-report', '067'),
    exact: true
  },
  {
    path: '/blog/tags/flying-saucer',
    component: ComponentCreator('/blog/tags/flying-saucer', 'dfe'),
    exact: true
  },
  {
    path: '/blog/tags/font-embedding',
    component: ComponentCreator('/blog/tags/font-embedding', '15c'),
    exact: true
  },
  {
    path: '/blog/tags/footer-template',
    component: ComponentCreator('/blog/tags/footer-template', '839'),
    exact: true
  },
  {
    path: '/blog/tags/form-to-pdf',
    component: ComponentCreator('/blog/tags/form-to-pdf', '3c7'),
    exact: true
  },
  {
    path: '/blog/tags/fpdf',
    component: ComponentCreator('/blog/tags/fpdf', 'fe8'),
    exact: true
  },
  {
    path: '/blog/tags/freemarker',
    component: ComponentCreator('/blog/tags/freemarker', '53f'),
    exact: true
  },
  {
    path: '/blog/tags/generate-invoice-pdf',
    component: ComponentCreator('/blog/tags/generate-invoice-pdf', 'b8c'),
    exact: true
  },
  {
    path: '/blog/tags/generate-pdf',
    component: ComponentCreator('/blog/tags/generate-pdf', 'ea3'),
    exact: true
  },
  {
    path: '/blog/tags/grover-gem',
    component: ComponentCreator('/blog/tags/grover-gem', 'f87'),
    exact: true
  },
  {
    path: '/blog/tags/handlebars',
    component: ComponentCreator('/blog/tags/handlebars', '4fb'),
    exact: true
  },
  {
    path: '/blog/tags/handlebars-pdf',
    component: ComponentCreator('/blog/tags/handlebars-pdf', '35b'),
    exact: true
  },
  {
    path: '/blog/tags/handlebars-templates',
    component: ComponentCreator('/blog/tags/handlebars-templates', 'f6f'),
    exact: true
  },
  {
    path: '/blog/tags/header-template',
    component: ComponentCreator('/blog/tags/header-template', '3ba'),
    exact: true
  },
  {
    path: '/blog/tags/headless-chrome',
    component: ComponentCreator('/blog/tags/headless-chrome', '100'),
    exact: true
  },
  {
    path: '/blog/tags/hexapdf-gem',
    component: ComponentCreator('/blog/tags/hexapdf-gem', 'ca4'),
    exact: true
  },
  {
    path: '/blog/tags/html-2-canvas',
    component: ComponentCreator('/blog/tags/html-2-canvas', 'caa'),
    exact: true
  },
  {
    path: '/blog/tags/html-to-pdf',
    component: ComponentCreator('/blog/tags/html-to-pdf', '857'),
    exact: true
  },
  {
    path: '/blog/tags/html-to-pdf-api',
    component: ComponentCreator('/blog/tags/html-to-pdf-api', 'df8'),
    exact: true
  },
  {
    path: '/blog/tags/html-to-pdf-conversion',
    component: ComponentCreator('/blog/tags/html-to-pdf-conversion', '0ef'),
    exact: true
  },
  {
    path: '/blog/tags/html-to-pdf-footer',
    component: ComponentCreator('/blog/tags/html-to-pdf-footer', '466'),
    exact: true
  },
  {
    path: '/blog/tags/html-to-pdf-header',
    component: ComponentCreator('/blog/tags/html-to-pdf-header', '9b5'),
    exact: true
  },
  {
    path: '/blog/tags/html-to-pdf-header-footer',
    component: ComponentCreator('/blog/tags/html-to-pdf-header-footer', 'cb6'),
    exact: true
  },
  {
    path: '/blog/tags/html-to-pdf-nodejs',
    component: ComponentCreator('/blog/tags/html-to-pdf-nodejs', 'a1c'),
    exact: true
  },
  {
    path: '/blog/tags/html-to-pdf-page-numbers',
    component: ComponentCreator('/blog/tags/html-to-pdf-page-numbers', '758'),
    exact: true
  },
  {
    path: '/blog/tags/html-to-pdf/page/2',
    component: ComponentCreator('/blog/tags/html-to-pdf/page/2', '8ae'),
    exact: true
  },
  {
    path: '/blog/tags/html-to-pdf/page/3',
    component: ComponentCreator('/blog/tags/html-to-pdf/page/3', '844'),
    exact: true
  },
  {
    path: '/blog/tags/html-to-pdf/page/4',
    component: ComponentCreator('/blog/tags/html-to-pdf/page/4', '40e'),
    exact: true
  },
  {
    path: '/blog/tags/icc-profile',
    component: ComponentCreator('/blog/tags/icc-profile', 'e1c'),
    exact: true
  },
  {
    path: '/blog/tags/image-optimization',
    component: ComponentCreator('/blog/tags/image-optimization', '293'),
    exact: true
  },
  {
    path: '/blog/tags/invoice-automation',
    component: ComponentCreator('/blog/tags/invoice-automation', 'b10'),
    exact: true
  },
  {
    path: '/blog/tags/invoice-pdf',
    component: ComponentCreator('/blog/tags/invoice-pdf', 'e74'),
    exact: true
  },
  {
    path: '/blog/tags/invoice-pdf-api',
    component: ComponentCreator('/blog/tags/invoice-pdf-api', '298'),
    exact: true
  },
  {
    path: '/blog/tags/invoice-pdf-generator',
    component: ComponentCreator('/blog/tags/invoice-pdf-generator', '519'),
    exact: true
  },
  {
    path: '/blog/tags/invoice-pdf-template',
    component: ComponentCreator('/blog/tags/invoice-pdf-template', 'cf8'),
    exact: true
  },
  {
    path: '/blog/tags/invoice-pdf/page/2',
    component: ComponentCreator('/blog/tags/invoice-pdf/page/2', '70b'),
    exact: true
  },
  {
    path: '/blog/tags/invoice-pdf/page/3',
    component: ComponentCreator('/blog/tags/invoice-pdf/page/3', '8a5'),
    exact: true
  },
  {
    path: '/blog/tags/invoice-workflow-automation',
    component: ComponentCreator('/blog/tags/invoice-workflow-automation', 'eea'),
    exact: true
  },
  {
    path: '/blog/tags/itext',
    component: ComponentCreator('/blog/tags/itext', '66f'),
    exact: true
  },
  {
    path: '/blog/tags/itext-7',
    component: ComponentCreator('/blog/tags/itext-7', 'f8e'),
    exact: true
  },
  {
    path: '/blog/tags/itextsharp',
    component: ComponentCreator('/blog/tags/itextsharp', '251'),
    exact: true
  },
  {
    path: '/blog/tags/java',
    component: ComponentCreator('/blog/tags/java', '5fd'),
    exact: true
  },
  {
    path: '/blog/tags/java-html-to-pdf',
    component: ComponentCreator('/blog/tags/java-html-to-pdf', '0ed'),
    exact: true
  },
  {
    path: '/blog/tags/java-html-to-pdf-library',
    component: ComponentCreator('/blog/tags/java-html-to-pdf-library', 'b62'),
    exact: true
  },
  {
    path: '/blog/tags/java-pdf-compression',
    component: ComponentCreator('/blog/tags/java-pdf-compression', 'a88'),
    exact: true
  },
  {
    path: '/blog/tags/java-pdf-generation',
    component: ComponentCreator('/blog/tags/java-pdf-generation', 'ce0'),
    exact: true
  },
  {
    path: '/blog/tags/java-pdf-generation-library',
    component: ComponentCreator('/blog/tags/java-pdf-generation-library', 'a65'),
    exact: true
  },
  {
    path: '/blog/tags/java-pdf-invoice',
    component: ComponentCreator('/blog/tags/java-pdf-invoice', '75d'),
    exact: true
  },
  {
    path: '/blog/tags/java-pdf-libraries-comparison',
    component: ComponentCreator('/blog/tags/java-pdf-libraries-comparison', 'edd'),
    exact: true
  },
  {
    path: '/blog/tags/java-pdf-library',
    component: ComponentCreator('/blog/tags/java-pdf-library', 'be3'),
    exact: true
  },
  {
    path: '/blog/tags/javascript',
    component: ComponentCreator('/blog/tags/javascript', 'f8b'),
    exact: true
  },
  {
    path: '/blog/tags/javascript-pdf-generation-library',
    component: ComponentCreator('/blog/tags/javascript-pdf-generation-library', '334'),
    exact: true
  },
  {
    path: '/blog/tags/jinja-2',
    component: ComponentCreator('/blog/tags/jinja-2', 'e94'),
    exact: true
  },
  {
    path: '/blog/tags/jspdf',
    component: ComponentCreator('/blog/tags/jspdf', 'b95'),
    exact: true
  },
  {
    path: '/blog/tags/jspdf-html-to-pdf',
    component: ComponentCreator('/blog/tags/jspdf-html-to-pdf', 'b15'),
    exact: true
  },
  {
    path: '/blog/tags/jspdf-tutorial',
    component: ComponentCreator('/blog/tags/jspdf-tutorial', '17a'),
    exact: true
  },
  {
    path: '/blog/tags/library-comparison',
    component: ComponentCreator('/blog/tags/library-comparison', 'ebc'),
    exact: true
  },
  {
    path: '/blog/tags/mako',
    component: ComponentCreator('/blog/tags/mako', '67c'),
    exact: true
  },
  {
    path: '/blog/tags/modify-pdf',
    component: ComponentCreator('/blog/tags/modify-pdf', 'e18'),
    exact: true
  },
  {
    path: '/blog/tags/mpdf',
    component: ComponentCreator('/blog/tags/mpdf', 'd5b'),
    exact: true
  },
  {
    path: '/blog/tags/n-8-n-community-node',
    component: ComponentCreator('/blog/tags/n-8-n-community-node', '620'),
    exact: true
  },
  {
    path: '/blog/tags/n-8-n-document-generation',
    component: ComponentCreator('/blog/tags/n-8-n-document-generation', '5b3'),
    exact: true
  },
  {
    path: '/blog/tags/n-8-n-html-to-pdf',
    component: ComponentCreator('/blog/tags/n-8-n-html-to-pdf', '7d9'),
    exact: true
  },
  {
    path: '/blog/tags/n-8-n-invoice-automation',
    component: ComponentCreator('/blog/tags/n-8-n-invoice-automation', '504'),
    exact: true
  },
  {
    path: '/blog/tags/n-8-n-pdf',
    component: ComponentCreator('/blog/tags/n-8-n-pdf', 'bdc'),
    exact: true
  },
  {
    path: '/blog/tags/n-8-n-pdf-api-integration',
    component: ComponentCreator('/blog/tags/n-8-n-pdf-api-integration', '7e2'),
    exact: true
  },
  {
    path: '/blog/tags/n-8-n-pdf-automation-tutorial',
    component: ComponentCreator('/blog/tags/n-8-n-pdf-automation-tutorial', '5f7'),
    exact: true
  },
  {
    path: '/blog/tags/n-8-n-pdf-generation',
    component: ComponentCreator('/blog/tags/n-8-n-pdf-generation', 'ec9'),
    exact: true
  },
  {
    path: '/blog/tags/n-8-n-shopify-invoice',
    component: ComponentCreator('/blog/tags/n-8-n-shopify-invoice', '00c'),
    exact: true
  },
  {
    path: '/blog/tags/n-8-n-stripe',
    component: ComponentCreator('/blog/tags/n-8-n-stripe', 'a61'),
    exact: true
  },
  {
    path: '/blog/tags/n-8-n-stripe-invoice',
    component: ComponentCreator('/blog/tags/n-8-n-stripe-invoice', 'd57'),
    exact: true
  },
  {
    path: '/blog/tags/n-8-n-workflow-examples',
    component: ComponentCreator('/blog/tags/n-8-n-workflow-examples', '955'),
    exact: true
  },
  {
    path: '/blog/tags/n-8-n-workflow-templates',
    component: ComponentCreator('/blog/tags/n-8-n-workflow-templates', '3f4'),
    exact: true
  },
  {
    path: '/blog/tags/no-code-document-automation',
    component: ComponentCreator('/blog/tags/no-code-document-automation', '640'),
    exact: true
  },
  {
    path: '/blog/tags/nodejs',
    component: ComponentCreator('/blog/tags/nodejs', '138'),
    exact: true
  },
  {
    path: '/blog/tags/nodejs-html-to-pdf-library',
    component: ComponentCreator('/blog/tags/nodejs-html-to-pdf-library', 'ada'),
    exact: true
  },
  {
    path: '/blog/tags/nodejs-pdf-generation-library',
    component: ComponentCreator('/blog/tags/nodejs-pdf-generation-library', '769'),
    exact: true
  },
  {
    path: '/blog/tags/openpdf',
    component: ComponentCreator('/blog/tags/openpdf', '3e0'),
    exact: true
  },
  {
    path: '/blog/tags/openpdf-tutorial',
    component: ComponentCreator('/blog/tags/openpdf-tutorial', 'ce9'),
    exact: true
  },
  {
    path: '/blog/tags/optimization',
    component: ComponentCreator('/blog/tags/optimization', '662'),
    exact: true
  },
  {
    path: '/blog/tags/optimize-pdf-java',
    component: ComponentCreator('/blog/tags/optimize-pdf-java', 'f01'),
    exact: true
  },
  {
    path: '/blog/tags/page-breaks',
    component: ComponentCreator('/blog/tags/page-breaks', '366'),
    exact: true
  },
  {
    path: '/blog/tags/pdf',
    component: ComponentCreator('/blog/tags/pdf', '72d'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-accessibility',
    component: ComponentCreator('/blog/tags/pdf-accessibility', '57a'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-api',
    component: ComponentCreator('/blog/tags/pdf-api', '142'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-automation',
    component: ComponentCreator('/blog/tags/pdf-automation', '37a'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-compression',
    component: ComponentCreator('/blog/tags/pdf-compression', '8c1'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-compression-api',
    component: ComponentCreator('/blog/tags/pdf-compression-api', '7bd'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-conversion',
    component: ComponentCreator('/blog/tags/pdf-conversion', 'ffd'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-converter',
    component: ComponentCreator('/blog/tags/pdf-converter', 'b23'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-file-size',
    component: ComponentCreator('/blog/tags/pdf-file-size', '6f6'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-footer-page-numbers',
    component: ComponentCreator('/blog/tags/pdf-footer-page-numbers', '5cb'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-generation',
    component: ComponentCreator('/blog/tags/pdf-generation', '4b7'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-generation-api',
    component: ComponentCreator('/blog/tags/pdf-generation-api', '9b6'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-generation/page/2',
    component: ComponentCreator('/blog/tags/pdf-generation/page/2', '93d'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-generation/page/3',
    component: ComponentCreator('/blog/tags/pdf-generation/page/3', 'cb3'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-generation/page/4',
    component: ComponentCreator('/blog/tags/pdf-generation/page/4', '963'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-invoice-nodejs',
    component: ComponentCreator('/blog/tags/pdf-invoice-nodejs', '42d'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-invoice-python',
    component: ComponentCreator('/blog/tags/pdf-invoice-python', '3f0'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-lib',
    component: ComponentCreator('/blog/tags/pdf-lib', '564'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-lib-nodejs',
    component: ComponentCreator('/blog/tags/pdf-lib-nodejs', '371'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-lib-tutorial',
    component: ComponentCreator('/blog/tags/pdf-lib-tutorial', '78a'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-optimization',
    component: ComponentCreator('/blog/tags/pdf-optimization', '78c'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-security',
    component: ComponentCreator('/blog/tags/pdf-security', 'daf'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-standards',
    component: ComponentCreator('/blog/tags/pdf-standards', '9fc'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-tagging',
    component: ComponentCreator('/blog/tags/pdf-tagging', '320'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-template-engine',
    component: ComponentCreator('/blog/tags/pdf-template-engine', '5d7'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-templates',
    component: ComponentCreator('/blog/tags/pdf-templates', '241'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-ua',
    component: ComponentCreator('/blog/tags/pdf-ua', 'b3b'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-workflow-automation',
    component: ComponentCreator('/blog/tags/pdf-workflow-automation', '2a3'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-x-1-a',
    component: ComponentCreator('/blog/tags/pdf-x-1-a', 'e2d'),
    exact: true
  },
  {
    path: '/blog/tags/pdf-x-4',
    component: ComponentCreator('/blog/tags/pdf-x-4', '5a3'),
    exact: true
  },
  {
    path: '/blog/tags/pdfbolt',
    component: ComponentCreator('/blog/tags/pdfbolt', 'e37'),
    exact: true
  },
  {
    path: '/blog/tags/pdfbox-compress-pdf',
    component: ComponentCreator('/blog/tags/pdfbox-compress-pdf', 'b70'),
    exact: true
  },
  {
    path: '/blog/tags/pdfbox-image-compression',
    component: ComponentCreator('/blog/tags/pdfbox-image-compression', '058'),
    exact: true
  },
  {
    path: '/blog/tags/pdfkit',
    component: ComponentCreator('/blog/tags/pdfkit', 'a79'),
    exact: true
  },
  {
    path: '/blog/tags/pdfkit-python',
    component: ComponentCreator('/blog/tags/pdfkit-python', '6a3'),
    exact: true
  },
  {
    path: '/blog/tags/pdfkit-tutorial',
    component: ComponentCreator('/blog/tags/pdfkit-tutorial', '742'),
    exact: true
  },
  {
    path: '/blog/tags/pdfmake',
    component: ComponentCreator('/blog/tags/pdfmake', '62a'),
    exact: true
  },
  {
    path: '/blog/tags/pdfmake-nodejs',
    component: ComponentCreator('/blog/tags/pdfmake-nodejs', 'b12'),
    exact: true
  },
  {
    path: '/blog/tags/pdfmake-tutorial',
    component: ComponentCreator('/blog/tags/pdfmake-tutorial', '38e'),
    exact: true
  },
  {
    path: '/blog/tags/pdfsharp',
    component: ComponentCreator('/blog/tags/pdfsharp', '2a5'),
    exact: true
  },
  {
    path: '/blog/tags/pdfsharp-html-to-pdf',
    component: ComponentCreator('/blog/tags/pdfsharp-html-to-pdf', '9e8'),
    exact: true
  },
  {
    path: '/blog/tags/php',
    component: ComponentCreator('/blog/tags/php', 'd76'),
    exact: true
  },
  {
    path: '/blog/tags/php-html-to-pdf',
    component: ComponentCreator('/blog/tags/php-html-to-pdf', 'e78'),
    exact: true
  },
  {
    path: '/blog/tags/php-html-to-pdf-library',
    component: ComponentCreator('/blog/tags/php-html-to-pdf-library', '0f0'),
    exact: true
  },
  {
    path: '/blog/tags/php-pdf-generation',
    component: ComponentCreator('/blog/tags/php-pdf-generation', '04c'),
    exact: true
  },
  {
    path: '/blog/tags/php-pdf-generation-library',
    component: ComponentCreator('/blog/tags/php-pdf-generation-library', '888'),
    exact: true
  },
  {
    path: '/blog/tags/php-pdf-generator',
    component: ComponentCreator('/blog/tags/php-pdf-generator', '132'),
    exact: true
  },
  {
    path: '/blog/tags/php-pdf-libraries-comparison',
    component: ComponentCreator('/blog/tags/php-pdf-libraries-comparison', '4d5'),
    exact: true
  },
  {
    path: '/blog/tags/playwright',
    component: ComponentCreator('/blog/tags/playwright', '08c'),
    exact: true
  },
  {
    path: '/blog/tags/portable-document-format',
    component: ComponentCreator('/blog/tags/portable-document-format', 'cfa'),
    exact: true
  },
  {
    path: '/blog/tags/prawn-gem',
    component: ComponentCreator('/blog/tags/prawn-gem', 'ce9'),
    exact: true
  },
  {
    path: '/blog/tags/prepress',
    component: ComponentCreator('/blog/tags/prepress', '47f'),
    exact: true
  },
  {
    path: '/blog/tags/princexml',
    component: ComponentCreator('/blog/tags/princexml', '1aa'),
    exact: true
  },
  {
    path: '/blog/tags/print-production',
    component: ComponentCreator('/blog/tags/print-production', '90b'),
    exact: true
  },
  {
    path: '/blog/tags/print-ready-pdf',
    component: ComponentCreator('/blog/tags/print-ready-pdf', '56c'),
    exact: true
  },
  {
    path: '/blog/tags/print-styling',
    component: ComponentCreator('/blog/tags/print-styling', '946'),
    exact: true
  },
  {
    path: '/blog/tags/product-update',
    component: ComponentCreator('/blog/tags/product-update', 'd3c'),
    exact: true
  },
  {
    path: '/blog/tags/puppeteer',
    component: ComponentCreator('/blog/tags/puppeteer', 'dc5'),
    exact: true
  },
  {
    path: '/blog/tags/puppeteer-ruby-gem',
    component: ComponentCreator('/blog/tags/puppeteer-ruby-gem', 'c9f'),
    exact: true
  },
  {
    path: '/blog/tags/puppeteersharp',
    component: ComponentCreator('/blog/tags/puppeteersharp', 'd65'),
    exact: true
  },
  {
    path: '/blog/tags/pypdf-2',
    component: ComponentCreator('/blog/tags/pypdf-2', '789'),
    exact: true
  },
  {
    path: '/blog/tags/pyppeteer',
    component: ComponentCreator('/blog/tags/pyppeteer', '3af'),
    exact: true
  },
  {
    path: '/blog/tags/python',
    component: ComponentCreator('/blog/tags/python', 'eb9'),
    exact: true
  },
  {
    path: '/blog/tags/python-html-to-pdf',
    component: ComponentCreator('/blog/tags/python-html-to-pdf', '298'),
    exact: true
  },
  {
    path: '/blog/tags/python-html-to-pdf-library',
    component: ComponentCreator('/blog/tags/python-html-to-pdf-library', '6e0'),
    exact: true
  },
  {
    path: '/blog/tags/python-pdf-generation',
    component: ComponentCreator('/blog/tags/python-pdf-generation', 'f72'),
    exact: true
  },
  {
    path: '/blog/tags/python-pdf-generation-library',
    component: ComponentCreator('/blog/tags/python-pdf-generation-library', 'f9c'),
    exact: true
  },
  {
    path: '/blog/tags/qr-code-pdf',
    component: ComponentCreator('/blog/tags/qr-code-pdf', '38f'),
    exact: true
  },
  {
    path: '/blog/tags/questpdf',
    component: ComponentCreator('/blog/tags/questpdf', '4a3'),
    exact: true
  },
  {
    path: '/blog/tags/questpdf-example',
    component: ComponentCreator('/blog/tags/questpdf-example', '61e'),
    exact: true
  },
  {
    path: '/blog/tags/rails-html-to-pdf-library',
    component: ComponentCreator('/blog/tags/rails-html-to-pdf-library', 'f08'),
    exact: true
  },
  {
    path: '/blog/tags/rails-pdf',
    component: ComponentCreator('/blog/tags/rails-pdf', 'cd0'),
    exact: true
  },
  {
    path: '/blog/tags/razor',
    component: ComponentCreator('/blog/tags/razor', 'e7a'),
    exact: true
  },
  {
    path: '/blog/tags/recipe-card',
    component: ComponentCreator('/blog/tags/recipe-card', '128'),
    exact: true
  },
  {
    path: '/blog/tags/reduce-pdf-file-size-java',
    component: ComponentCreator('/blog/tags/reduce-pdf-file-size-java', '7c6'),
    exact: true
  },
  {
    path: '/blog/tags/reduce-pdf-size',
    component: ComponentCreator('/blog/tags/reduce-pdf-size', '793'),
    exact: true
  },
  {
    path: '/blog/tags/rest-api',
    component: ComponentCreator('/blog/tags/rest-api', 'a13'),
    exact: true
  },
  {
    path: '/blog/tags/rgb-to-cmyk',
    component: ComponentCreator('/blog/tags/rgb-to-cmyk', 'e5d'),
    exact: true
  },
  {
    path: '/blog/tags/ruby',
    component: ComponentCreator('/blog/tags/ruby', '813'),
    exact: true
  },
  {
    path: '/blog/tags/ruby-html-to-pdf',
    component: ComponentCreator('/blog/tags/ruby-html-to-pdf', '969'),
    exact: true
  },
  {
    path: '/blog/tags/ruby-on-rails',
    component: ComponentCreator('/blog/tags/ruby-on-rails', 'f25'),
    exact: true
  },
  {
    path: '/blog/tags/ruby-on-rails-pdf-generator',
    component: ComponentCreator('/blog/tags/ruby-on-rails-pdf-generator', '177'),
    exact: true
  },
  {
    path: '/blog/tags/ruby-pdf-generation-library',
    component: ComponentCreator('/blog/tags/ruby-pdf-generation-library', '3ee'),
    exact: true
  },
  {
    path: '/blog/tags/ruby-tutorial',
    component: ComponentCreator('/blog/tags/ruby-tutorial', '815'),
    exact: true
  },
  {
    path: '/blog/tags/save-webpage-as-pdf',
    component: ComponentCreator('/blog/tags/save-webpage-as-pdf', 'd53'),
    exact: true
  },
  {
    path: '/blog/tags/screen-reader-compatibility',
    component: ComponentCreator('/blog/tags/screen-reader-compatibility', '091'),
    exact: true
  },
  {
    path: '/blog/tags/scriban',
    component: ComponentCreator('/blog/tags/scriban', '5cb'),
    exact: true
  },
  {
    path: '/blog/tags/section-508',
    component: ComponentCreator('/blog/tags/section-508', '8a2'),
    exact: true
  },
  {
    path: '/blog/tags/server-side',
    component: ComponentCreator('/blog/tags/server-side', 'c94'),
    exact: true
  },
  {
    path: '/blog/tags/snappy',
    component: ComponentCreator('/blog/tags/snappy', 'ecf'),
    exact: true
  },
  {
    path: '/blog/tags/software-development',
    component: ComponentCreator('/blog/tags/software-development', 'eaf'),
    exact: true
  },
  {
    path: '/blog/tags/tcpdf',
    component: ComponentCreator('/blog/tags/tcpdf', '567'),
    exact: true
  },
  {
    path: '/blog/tags/team-feature',
    component: ComponentCreator('/blog/tags/team-feature', 'fda'),
    exact: true
  },
  {
    path: '/blog/tags/template-engines',
    component: ComponentCreator('/blog/tags/template-engines', '075'),
    exact: true
  },
  {
    path: '/blog/tags/template-generation',
    component: ComponentCreator('/blog/tags/template-generation', '134'),
    exact: true
  },
  {
    path: '/blog/tags/thymeleaf',
    component: ComponentCreator('/blog/tags/thymeleaf', '1b4'),
    exact: true
  },
  {
    path: '/blog/tags/twig',
    component: ComponentCreator('/blog/tags/twig', '203'),
    exact: true
  },
  {
    path: '/blog/tags/url-to-pdf-api',
    component: ComponentCreator('/blog/tags/url-to-pdf-api', '5c6'),
    exact: true
  },
  {
    path: '/blog/tags/wcag-compliance',
    component: ComponentCreator('/blog/tags/wcag-compliance', '5c9'),
    exact: true
  },
  {
    path: '/blog/tags/weasyprint',
    component: ComponentCreator('/blog/tags/weasyprint', '040'),
    exact: true
  },
  {
    path: '/blog/tags/web-to-pdf',
    component: ComponentCreator('/blog/tags/web-to-pdf', '6a0'),
    exact: true
  },
  {
    path: '/blog/tags/webpage-to-pdf',
    component: ComponentCreator('/blog/tags/webpage-to-pdf', '76b'),
    exact: true
  },
  {
    path: '/blog/tags/wickedpdf-gem',
    component: ComponentCreator('/blog/tags/wickedpdf-gem', '61b'),
    exact: true
  },
  {
    path: '/blog/tags/wkhtmltopdf',
    component: ComponentCreator('/blog/tags/wkhtmltopdf', '887'),
    exact: true
  },
  {
    path: '/blog/tags/wkhtmltopdf-alternative',
    component: ComponentCreator('/blog/tags/wkhtmltopdf-alternative', '7f1'),
    exact: true
  },
  {
    path: '/blog/tags/workflow',
    component: ComponentCreator('/blog/tags/workflow', '809'),
    exact: true
  },
  {
    path: '/blog/tags/xhtml-2-pdf',
    component: ComponentCreator('/blog/tags/xhtml-2-pdf', '0ce'),
    exact: true
  },
  {
    path: '/blog/tags/xhtmlrenderer',
    component: ComponentCreator('/blog/tags/xhtmlrenderer', '1eb'),
    exact: true
  },
  {
    path: '/blog/team-feature',
    component: ComponentCreator('/blog/team-feature', '642'),
    exact: true
  },
  {
    path: '/blog/top-csharp-pdf-generation-libraries',
    component: ComponentCreator('/blog/top-csharp-pdf-generation-libraries', '135'),
    exact: true
  },
  {
    path: '/blog/top-java-pdf-generation-libraries',
    component: ComponentCreator('/blog/top-java-pdf-generation-libraries', '8bc'),
    exact: true
  },
  {
    path: '/blog/top-nodejs-pdf-generation-libraries',
    component: ComponentCreator('/blog/top-nodejs-pdf-generation-libraries', 'f49'),
    exact: true
  },
  {
    path: '/blog/top-php-pdf-generation-libraries',
    component: ComponentCreator('/blog/top-php-pdf-generation-libraries', 'c6a'),
    exact: true
  },
  {
    path: '/blog/top-ruby-rails-pdf-generation-gems',
    component: ComponentCreator('/blog/top-ruby-rails-pdf-generation-gems', '1b0'),
    exact: true
  },
  {
    path: '/changelog',
    component: ComponentCreator('/changelog', '839'),
    exact: true
  },
  {
    path: '/compare',
    component: ComponentCreator('/compare', '2b4'),
    exact: true
  },
  {
    path: '/compare/browserless',
    component: ComponentCreator('/compare/browserless', '379'),
    exact: true
  },
  {
    path: '/compare/docraptor',
    component: ComponentCreator('/compare/docraptor', 'a70'),
    exact: true
  },
  {
    path: '/compare/gotenberg',
    component: ComponentCreator('/compare/gotenberg', '6d8'),
    exact: true
  },
  {
    path: '/compare/ironpdf',
    component: ComponentCreator('/compare/ironpdf', '947'),
    exact: true
  },
  {
    path: '/compare/pdfshift',
    component: ComponentCreator('/compare/pdfshift', '229'),
    exact: true
  },
  {
    path: '/compare/puppeteer',
    component: ComponentCreator('/compare/puppeteer', '4f3'),
    exact: true
  },
  {
    path: '/compare/wkhtmltopdf',
    component: ComponentCreator('/compare/wkhtmltopdf', '6d5'),
    exact: true
  },
  {
    path: '/contact',
    component: ComponentCreator('/contact', 'abe'),
    exact: true
  },
  {
    path: '/customers',
    component: ComponentCreator('/customers', '2ca'),
    exact: true
  },
  {
    path: '/customers/bubbletax',
    component: ComponentCreator('/customers/bubbletax', '79f'),
    exact: true
  },
  {
    path: '/data-processing-agreement',
    component: ComponentCreator('/data-processing-agreement', 'bf0'),
    exact: true
  },
  {
    path: '/docs/api-reference',
    component: ComponentCreator('/docs/api-reference', '46c'),
    exact: true,
    showNavLink: false,
    label: "OpenAPI Reference",
    route: "/docs/api-reference",
    cdn: "https://cdn.jsdelivr.net/npm/@scalar/api-reference@1.55.3/dist/browser/standalone.js",
    configuration: {"_integration":"docusaurus","url":"/openapi.yaml","servers":[{"url":"https://api.pdfbolt.com","description":"PDFBolt API"}],"title":"PDFBolt API Reference","layout":"modern","theme":"default","documentDownloadType":"yaml","hideDownloadButton":false,"hideModels":false,"hideClientButton":true,"hideTestRequestButton":false,"persistAuth":false,"telemetry":false,"showSidebar":true,"showDeveloperTools":"never","showToolbar":"never","operationTitleSource":"path","defaultHttpClient":{"targetKey":"shell","clientKey":"curl"},"orderSchemaPropertiesBy":"preserve","orderRequiredPropertiesFirst":true,"agent":{"disabled":true},"mcp":{"disabled":true}},
    id: "default"
  },
  {
    path: '/form-to-pdf',
    component: ComponentCreator('/form-to-pdf', 'ea0'),
    exact: true
  },
  {
    path: '/html-to-pdf-api',
    component: ComponentCreator('/html-to-pdf-api', '943'),
    exact: true
  },
  {
    path: '/industries/ecommerce',
    component: ComponentCreator('/industries/ecommerce', 'a2c'),
    exact: true
  },
  {
    path: '/industries/healthcare',
    component: ComponentCreator('/industries/healthcare', 'c54'),
    exact: true
  },
  {
    path: '/industries/human-resources',
    component: ComponentCreator('/industries/human-resources', '500'),
    exact: true
  },
  {
    path: '/industries/legal',
    component: ComponentCreator('/industries/legal', '19f'),
    exact: true
  },
  {
    path: '/industries/logistics',
    component: ComponentCreator('/industries/logistics', '999'),
    exact: true
  },
  {
    path: '/nonprofits',
    component: ComponentCreator('/nonprofits', '177'),
    exact: true
  },
  {
    path: '/pdf-templates',
    component: ComponentCreator('/pdf-templates', '041'),
    exact: true
  },
  {
    path: '/pdf-templates/brochures',
    component: ComponentCreator('/pdf-templates/brochures', '03a'),
    exact: true
  },
  {
    path: '/pdf-templates/brochures/business-tri-fold-brochure',
    component: ComponentCreator('/pdf-templates/brochures/business-tri-fold-brochure', 'f9c'),
    exact: true
  },
  {
    path: '/pdf-templates/certificates',
    component: ComponentCreator('/pdf-templates/certificates', 'e12'),
    exact: true
  },
  {
    path: '/pdf-templates/certificates/classic-wine-gold-certificate',
    component: ComponentCreator('/pdf-templates/certificates/classic-wine-gold-certificate', '156'),
    exact: true
  },
  {
    path: '/pdf-templates/certificates/elegant-geometric-certificate',
    component: ComponentCreator('/pdf-templates/certificates/elegant-geometric-certificate', 'b45'),
    exact: true
  },
  {
    path: '/pdf-templates/certificates/modern-professional-certificate',
    component: ComponentCreator('/pdf-templates/certificates/modern-professional-certificate', '853'),
    exact: true
  },
  {
    path: '/pdf-templates/ebooks',
    component: ComponentCreator('/pdf-templates/ebooks', 'b4d'),
    exact: true
  },
  {
    path: '/pdf-templates/ebooks/classic-ebook-layout',
    component: ComponentCreator('/pdf-templates/ebooks/classic-ebook-layout', '0e0'),
    exact: true
  },
  {
    path: '/pdf-templates/ecommerce',
    component: ComponentCreator('/pdf-templates/ecommerce', '13b'),
    exact: true
  },
  {
    path: '/pdf-templates/ecommerce/clean-order-confirmation',
    component: ComponentCreator('/pdf-templates/ecommerce/clean-order-confirmation', 'e82'),
    exact: true
  },
  {
    path: '/pdf-templates/ecommerce/framed-gold-receipt',
    component: ComponentCreator('/pdf-templates/ecommerce/framed-gold-receipt', '12e'),
    exact: true
  },
  {
    path: '/pdf-templates/ecommerce/minimal-bw-receipt',
    component: ComponentCreator('/pdf-templates/ecommerce/minimal-bw-receipt', '883'),
    exact: true
  },
  {
    path: '/pdf-templates/ecommerce/simple-receipt',
    component: ComponentCreator('/pdf-templates/ecommerce/simple-receipt', '8ae'),
    exact: true
  },
  {
    path: '/pdf-templates/forms',
    component: ComponentCreator('/pdf-templates/forms', '439'),
    exact: true
  },
  {
    path: '/pdf-templates/forms/event-registration-form',
    component: ComponentCreator('/pdf-templates/forms/event-registration-form', '3f6'),
    exact: true
  },
  {
    path: '/pdf-templates/healthcare',
    component: ComponentCreator('/pdf-templates/healthcare', '292'),
    exact: true
  },
  {
    path: '/pdf-templates/healthcare/electronic-prescription-with-barcode',
    component: ComponentCreator('/pdf-templates/healthcare/electronic-prescription-with-barcode', '5f3'),
    exact: true
  },
  {
    path: '/pdf-templates/healthcare/medical-lab-test-report',
    component: ComponentCreator('/pdf-templates/healthcare/medical-lab-test-report', '3e1'),
    exact: true
  },
  {
    path: '/pdf-templates/healthcare/patient-medical-record',
    component: ComponentCreator('/pdf-templates/healthcare/patient-medical-record', 'ba6'),
    exact: true
  },
  {
    path: '/pdf-templates/human-resources',
    component: ComponentCreator('/pdf-templates/human-resources', '5a8'),
    exact: true
  },
  {
    path: '/pdf-templates/human-resources/detailed-performance-review',
    component: ComponentCreator('/pdf-templates/human-resources/detailed-performance-review', 'de6'),
    exact: true
  },
  {
    path: '/pdf-templates/human-resources/employee-onboarding-checklist',
    component: ComponentCreator('/pdf-templates/human-resources/employee-onboarding-checklist', 'a48'),
    exact: true
  },
  {
    path: '/pdf-templates/human-resources/formal-job-offer-letter',
    component: ComponentCreator('/pdf-templates/human-resources/formal-job-offer-letter', '11a'),
    exact: true
  },
  {
    path: '/pdf-templates/invoices',
    component: ComponentCreator('/pdf-templates/invoices', '26c'),
    exact: true
  },
  {
    path: '/pdf-templates/invoices/classic-business-invoice',
    component: ComponentCreator('/pdf-templates/invoices/classic-business-invoice', 'a32'),
    exact: true
  },
  {
    path: '/pdf-templates/invoices/clean-orange-invoice-with-qr-code',
    component: ComponentCreator('/pdf-templates/invoices/clean-orange-invoice-with-qr-code', '7e3'),
    exact: true
  },
  {
    path: '/pdf-templates/invoices/elegant-pink-invoice',
    component: ComponentCreator('/pdf-templates/invoices/elegant-pink-invoice', 'd79'),
    exact: true
  },
  {
    path: '/pdf-templates/invoices/modern-blue-invoice',
    component: ComponentCreator('/pdf-templates/invoices/modern-blue-invoice', '799'),
    exact: true
  },
  {
    path: '/pdf-templates/invoices/modern-invoice-with-qr-code',
    component: ComponentCreator('/pdf-templates/invoices/modern-invoice-with-qr-code', '54c'),
    exact: true
  },
  {
    path: '/pdf-templates/invoices/simple-green-invoice',
    component: ComponentCreator('/pdf-templates/invoices/simple-green-invoice', '737'),
    exact: true
  },
  {
    path: '/pdf-templates/legal-documents',
    component: ComponentCreator('/pdf-templates/legal-documents', '00c'),
    exact: true
  },
  {
    path: '/pdf-templates/legal-documents/complete-service-agreement',
    component: ComponentCreator('/pdf-templates/legal-documents/complete-service-agreement', '69c'),
    exact: true
  },
  {
    path: '/pdf-templates/legal-documents/comprehensive-employee-nda',
    component: ComponentCreator('/pdf-templates/legal-documents/comprehensive-employee-nda', '9fc'),
    exact: true
  },
  {
    path: '/pdf-templates/legal-documents/detailed-legal-brief',
    component: ComponentCreator('/pdf-templates/legal-documents/detailed-legal-brief', '3e9'),
    exact: true
  },
  {
    path: '/pdf-templates/legal-documents/elegant-mutual-nda',
    component: ComponentCreator('/pdf-templates/legal-documents/elegant-mutual-nda', 'd4a'),
    exact: true
  },
  {
    path: '/pdf-templates/legal-documents/formal-power-of-attorney',
    component: ComponentCreator('/pdf-templates/legal-documents/formal-power-of-attorney', '44b'),
    exact: true
  },
  {
    path: '/pdf-templates/legal-documents/one-page-service-agreement',
    component: ComponentCreator('/pdf-templates/legal-documents/one-page-service-agreement', '35f'),
    exact: true
  },
  {
    path: '/pdf-templates/legal-documents/professional-nda',
    component: ComponentCreator('/pdf-templates/legal-documents/professional-nda', 'e20'),
    exact: true
  },
  {
    path: '/pdf-templates/legal-documents/structured-employment-contract',
    component: ComponentCreator('/pdf-templates/legal-documents/structured-employment-contract', 'd21'),
    exact: true
  },
  {
    path: '/pdf-templates/logistics',
    component: ComponentCreator('/pdf-templates/logistics', '384'),
    exact: true
  },
  {
    path: '/pdf-templates/logistics/bill-of-lading',
    component: ComponentCreator('/pdf-templates/logistics/bill-of-lading', '0e3'),
    exact: true
  },
  {
    path: '/pdf-templates/logistics/commercial-invoice',
    component: ComponentCreator('/pdf-templates/logistics/commercial-invoice', '5a2'),
    exact: true
  },
  {
    path: '/pdf-templates/logistics/delivery-note',
    component: ComponentCreator('/pdf-templates/logistics/delivery-note', 'aec'),
    exact: true
  },
  {
    path: '/pdf-templates/logistics/packing-slip',
    component: ComponentCreator('/pdf-templates/logistics/packing-slip', 'f76'),
    exact: true
  },
  {
    path: '/pdf-templates/meetings',
    component: ComponentCreator('/pdf-templates/meetings', '6c8'),
    exact: true
  },
  {
    path: '/pdf-templates/meetings/meeting-minutes',
    component: ComponentCreator('/pdf-templates/meetings/meeting-minutes', '91a'),
    exact: true
  },
  {
    path: '/pdf-templates/proposals',
    component: ComponentCreator('/pdf-templates/proposals', 'e01'),
    exact: true
  },
  {
    path: '/pdf-templates/proposals/business-proposal',
    component: ComponentCreator('/pdf-templates/proposals/business-proposal', 'f18'),
    exact: true
  },
  {
    path: '/pdf-templates/quotes',
    component: ComponentCreator('/pdf-templates/quotes', '099'),
    exact: true
  },
  {
    path: '/pdf-templates/quotes/professional-business-quote',
    component: ComponentCreator('/pdf-templates/quotes/professional-business-quote', 'b92'),
    exact: true
  },
  {
    path: '/pdf-templates/receipts',
    component: ComponentCreator('/pdf-templates/receipts', 'bba'),
    exact: true
  },
  {
    path: '/pdf-templates/reports',
    component: ComponentCreator('/pdf-templates/reports', 'd74'),
    exact: true
  },
  {
    path: '/pdf-templates/reports/annual-business-report',
    component: ComponentCreator('/pdf-templates/reports/annual-business-report', '716'),
    exact: true
  },
  {
    path: '/pdf-templates/reports/project-status-report',
    component: ComponentCreator('/pdf-templates/reports/project-status-report', '211'),
    exact: true
  },
  {
    path: '/pdf-templates/resumes',
    component: ComponentCreator('/pdf-templates/resumes', '619'),
    exact: true
  },
  {
    path: '/pdf-templates/resumes/modern-dark-resume',
    component: ComponentCreator('/pdf-templates/resumes/modern-dark-resume', 'aa2'),
    exact: true
  },
  {
    path: '/pdf-templates/resumes/warm-professional-resume',
    component: ComponentCreator('/pdf-templates/resumes/warm-professional-resume', '536'),
    exact: true
  },
  {
    path: '/pdf-templates/shipping-labels',
    component: ComponentCreator('/pdf-templates/shipping-labels', '74b'),
    exact: true
  },
  {
    path: '/pdf-templates/shipping-labels/complete-shipping-label-with-barcode-qr-code',
    component: ComponentCreator('/pdf-templates/shipping-labels/complete-shipping-label-with-barcode-qr-code', '008'),
    exact: true
  },
  {
    path: '/pdf-templates/shipping-labels/standard-shipping-label-with-barcode-qr-code',
    component: ComponentCreator('/pdf-templates/shipping-labels/standard-shipping-label-with-barcode-qr-code', 'c65'),
    exact: true
  },
  {
    path: '/pdf-templates/tickets',
    component: ComponentCreator('/pdf-templates/tickets', '9cc'),
    exact: true
  },
  {
    path: '/pdf-templates/tickets/event-ticket',
    component: ComponentCreator('/pdf-templates/tickets/event-ticket', 'a32'),
    exact: true
  },
  {
    path: '/pdf-templates/vouchers',
    component: ComponentCreator('/pdf-templates/vouchers', '346'),
    exact: true
  },
  {
    path: '/pdf-templates/vouchers/christmas-gift-card',
    component: ComponentCreator('/pdf-templates/vouchers/christmas-gift-card', '642'),
    exact: true
  },
  {
    path: '/pdf-templates/vouchers/confetti-gift-card',
    component: ComponentCreator('/pdf-templates/vouchers/confetti-gift-card', '611'),
    exact: true
  },
  {
    path: '/pdf-templates/vouchers/spa-gift-voucher',
    component: ComponentCreator('/pdf-templates/vouchers/spa-gift-voucher', '2d2'),
    exact: true
  },
  {
    path: '/pricing',
    component: ComponentCreator('/pricing', '594'),
    exact: true
  },
  {
    path: '/privacy',
    component: ComponentCreator('/privacy', '476'),
    exact: true
  },
  {
    path: '/search',
    component: ComponentCreator('/search', '5de'),
    exact: true
  },
  {
    path: '/service-level-agreement',
    component: ComponentCreator('/service-level-agreement', '88b'),
    exact: true
  },
  {
    path: '/terms',
    component: ComponentCreator('/terms', '235'),
    exact: true
  },
  {
    path: '/tools',
    component: ComponentCreator('/tools', 'e95'),
    exact: true
  },
  {
    path: '/tools/free-certificate-generator',
    component: ComponentCreator('/tools/free-certificate-generator', 'b92'),
    exact: true
  },
  {
    path: '/tools/free-gift-card-generator',
    component: ComponentCreator('/tools/free-gift-card-generator', '007'),
    exact: true
  },
  {
    path: '/tools/free-html-to-pdf-converter',
    component: ComponentCreator('/tools/free-html-to-pdf-converter', '900'),
    exact: true
  },
  {
    path: '/tools/free-invoice-generator',
    component: ComponentCreator('/tools/free-invoice-generator', '24d'),
    exact: true
  },
  {
    path: '/tools/free-pdf-compressor',
    component: ComponentCreator('/tools/free-pdf-compressor', '96b'),
    exact: true
  },
  {
    path: '/tools/free-pdfx-converter',
    component: ComponentCreator('/tools/free-pdfx-converter', '9fd'),
    exact: true
  },
  {
    path: '/tools/free-quote-generator',
    component: ComponentCreator('/tools/free-quote-generator', '8e5'),
    exact: true
  },
  {
    path: '/tools/free-receipt-generator',
    component: ComponentCreator('/tools/free-receipt-generator', '156'),
    exact: true
  },
  {
    path: '/tools/free-resume-builder',
    component: ComponentCreator('/tools/free-resume-builder', 'fe7'),
    exact: true
  },
  {
    path: '/tools/free-shipping-label-generator',
    component: ComponentCreator('/tools/free-shipping-label-generator', '57c'),
    exact: true
  },
  {
    path: '/tools/free-url-to-pdf-converter',
    component: ComponentCreator('/tools/free-url-to-pdf-converter', '4fc'),
    exact: true
  },
  {
    path: '/url-to-pdf-api',
    component: ComponentCreator('/url-to-pdf-api', '773'),
    exact: true
  },
  {
    path: '/docs',
    component: ComponentCreator('/docs', '1c2'),
    routes: [
      {
        path: '/docs',
        component: ComponentCreator('/docs', '9f3'),
        routes: [
          {
            path: '/docs',
            component: ComponentCreator('/docs', '3b2'),
            routes: [
              {
                path: '/docs',
                component: ComponentCreator('/docs', 'c08'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/ai-pdf-template-generation',
                component: ComponentCreator('/docs/ai-pdf-template-generation', '12f'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-endpoints',
                component: ComponentCreator('/docs/api-endpoints', '876'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-endpoints/async',
                component: ComponentCreator('/docs/api-endpoints/async', '620'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-endpoints/direct',
                component: ComponentCreator('/docs/api-endpoints/direct', 'e45'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-endpoints/sync',
                component: ComponentCreator('/docs/api-endpoints/sync', '268'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-endpoints/template-api',
                component: ComponentCreator('/docs/api-endpoints/template-api', '17d'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/api-endpoints/usage-monitoring',
                component: ComponentCreator('/docs/api-endpoints/usage-monitoring', '912'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/async-workflow',
                component: ComponentCreator('/docs/async-workflow', '2c1'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/automation-platform-integrations',
                component: ComponentCreator('/docs/automation-platform-integrations', '92e'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/automation-platform-integrations/airtable-integration-guide',
                component: ComponentCreator('/docs/automation-platform-integrations/airtable-integration-guide', '8c6'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/automation-platform-integrations/bubble-integration-guide',
                component: ComponentCreator('/docs/automation-platform-integrations/bubble-integration-guide', '171'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/automation-platform-integrations/integrately-integration-guide',
                component: ComponentCreator('/docs/automation-platform-integrations/integrately-integration-guide', '5d1'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/automation-platform-integrations/make-integration-guide',
                component: ComponentCreator('/docs/automation-platform-integrations/make-integration-guide', '222'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/automation-platform-integrations/n8n-integration-guide',
                component: ComponentCreator('/docs/automation-platform-integrations/n8n-integration-guide', '8a6'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/automation-platform-integrations/n8n-integration-guide/http-request-node',
                component: ComponentCreator('/docs/automation-platform-integrations/n8n-integration-guide/http-request-node', '2d9'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/automation-platform-integrations/n8n-integration-guide/pdfbolt-community-node',
                component: ComponentCreator('/docs/automation-platform-integrations/n8n-integration-guide/pdfbolt-community-node', 'cc3'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/automation-platform-integrations/zapier-integration-guide',
                component: ComponentCreator('/docs/automation-platform-integrations/zapier-integration-guide', '9ce'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/dashboard',
                component: ComponentCreator('/docs/dashboard', '6b3'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/dashboard/api-keys',
                component: ComponentCreator('/docs/dashboard/api-keys', '732'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/dashboard/logs',
                component: ComponentCreator('/docs/dashboard/logs', '667'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/dashboard/playground',
                component: ComponentCreator('/docs/dashboard/playground', '905'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/dashboard/settings',
                component: ComponentCreator('/docs/dashboard/settings', '914'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/dashboard/subscription',
                component: ComponentCreator('/docs/dashboard/subscription', '904'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/dashboard/team',
                component: ComponentCreator('/docs/dashboard/team', 'c57'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/dashboard/templates',
                component: ComponentCreator('/docs/dashboard/templates', 'a20'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/error-handling',
                component: ComponentCreator('/docs/error-handling', 'ac4'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/faq',
                component: ComponentCreator('/docs/faq', '1e4'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/ip-addresses',
                component: ComponentCreator('/docs/ip-addresses', '38f'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/parameters',
                component: ComponentCreator('/docs/parameters', 'f5e'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/pdf-mcp-server',
                component: ComponentCreator('/docs/pdf-mcp-server', 'e25'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/pdf-mcp-server/claude',
                component: ComponentCreator('/docs/pdf-mcp-server/claude', 'fe7'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/pdf-mcp-server/claude-code',
                component: ComponentCreator('/docs/pdf-mcp-server/claude-code', 'd7f'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/pdf-mcp-server/codex',
                component: ComponentCreator('/docs/pdf-mcp-server/codex', '46f'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/pdf-mcp-server/cursor',
                component: ComponentCreator('/docs/pdf-mcp-server/cursor', '988'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/pdf-mcp-server/hermes-agent',
                component: ComponentCreator('/docs/pdf-mcp-server/hermes-agent', '6b1'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/pdf-mcp-server/openclaw',
                component: ComponentCreator('/docs/pdf-mcp-server/openclaw', '21a'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/pdf-mcp-server/other-clients',
                component: ComponentCreator('/docs/pdf-mcp-server/other-clients', '7f9'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/pdf-mcp-server/vs-code',
                component: ComponentCreator('/docs/pdf-mcp-server/vs-code', 'fcf'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/pdf-templates',
                component: ComponentCreator('/docs/pdf-templates', '6e4'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/privacy',
                component: ComponentCreator('/docs/privacy', 'b87'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/quick-start-guide',
                component: ComponentCreator('/docs/quick-start-guide', '34e'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/quick-start-guide/csharp',
                component: ComponentCreator('/docs/quick-start-guide/csharp', '286'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/quick-start-guide/go',
                component: ComponentCreator('/docs/quick-start-guide/go', '96c'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/quick-start-guide/java',
                component: ComponentCreator('/docs/quick-start-guide/java', '8cd'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/quick-start-guide/nodeJS',
                component: ComponentCreator('/docs/quick-start-guide/nodeJS', '58c'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/quick-start-guide/php',
                component: ComponentCreator('/docs/quick-start-guide/php', '574'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/quick-start-guide/postman',
                component: ComponentCreator('/docs/quick-start-guide/postman', '274'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/quick-start-guide/python',
                component: ComponentCreator('/docs/quick-start-guide/python', 'a18'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/quick-start-guide/rust',
                component: ComponentCreator('/docs/quick-start-guide/rust', 'f09'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/rate-limits',
                component: ComponentCreator('/docs/rate-limits', 'b86'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/s3-bucket-upload',
                component: ComponentCreator('/docs/s3-bucket-upload', 'b25'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/sdks',
                component: ComponentCreator('/docs/sdks', '30a'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/sdks/nodejs',
                component: ComponentCreator('/docs/sdks/nodejs', '56b'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/sdks/php',
                component: ComponentCreator('/docs/sdks/php', '0b5'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/docs/sdks/python',
                component: ComponentCreator('/docs/sdks/python', '98f'),
                exact: true,
                sidebar: "docsSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/',
    component: ComponentCreator('/', '2e1'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
